export default function hasPermission (permissions, permission) {
  if (permissions) {
    if (!String.prototype.includes) {
      if (permissions.indexOf(permission, 0) !== -1) {
        return true
      } else {
        if (permission.split(':').length === 3 && permission.split(':')[2] === 'self') {
          let permTmp = permission.split(':')[0] + ':' + permission.split(':')[1]
          return permissions.indexOf(permTmp, 0) !== -1
        }
        let permTmp = permission.split(':')[0] + ':*'
        return permissions.indexOf(permTmp, 0) !== -1
      }
    } else {
      if (permissions.includes(permission)) {
        return true
      } else {
        if (permission.split(':').length === 3 && permission.split(':')[2] === 'self') {
          let permTmp = permission.split(':')[0] + ':' + permission.split(':')[1]
          return permissions.includes(permTmp, 0) !== -1
        }
        let permTmp = permission.split(':')[0] + ':*'
        return permissions.includes(permTmp)
      }
    }
  }
}
export function hasRole (roles, role) {
  if (!String.prototype.includes) {
    if (roles.indexOf(role, 0) !== -1) {
      return true
    }
  } else {
    if (roles.includes(role)) {
      return true
    }
  }
}

export function handleCookieError (error, router) {
  if (error.response && error.response.status === 417) {
    // Si l'on a plus de cookie (expiré), on retourne à l'accueil
    router.push('accueil')
  } else {
    return Promise.reject(error)
  }
}
